import { render } from "./FileUpload.vue?vue&type=template&id=1c97b4c5"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"

import "./FileUpload.vue?vue&type=style&index=0&id=1c97b4c5&lang=css"
script.render = render

export default script